import {
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { sortableKeyboardCoordinates } from "@dnd-kit/sortable";

// Shared sensor set for sortable dnd-kit surfaces: pointer (mouse/touch) plus
// keyboard, so drag-reorder is operable without a mouse (WCAG 2.1.1). The 6px
// pointer activation distance preserves the existing click-vs-drag affordance;
// the keyboard sensor uses the sortable coordinate getter so arrow keys move an
// item through its list.
export function useSortableSensors() {
  return useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 6 } }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );
}
